/* eslint-disable no-restricted-imports */
/* eslint-disable functional/no-loop-statement */
import { newMostTitleSX } from '@/components/blocks/NewMost/styles/typography';
import { Grid, SxProps } from '@mui/material';
import { FC, useState, useEffect, useRef } from 'react';
import { DpH2 } from '@/components/blocks/DpLibrary/DPText';
import { combineSX } from '@/utils/combineSX';
import { Linkable } from '@/components/blocks/Linkable';
import {
	DpCatalogEntryCarouselHeaderButtonsFrameSX,
	DpCatalogEntryCarouselHeaderButtonSX,
} from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader/style/main';
import { DpContainer } from '@/components/blocks/DpContainer';

type Props = {
	title: string;
	href?: string;
	buttons?: { name: string; spot: string }[];
	titlesx?: SxProps;
	framesx?: SxProps;
	activeSpot: string;
	onSpotSelected: (spot: string) => void;
};

export const DpRenderCatalogEntryCarouselHeader: FC<Props> = ({
	title,
	href,
	buttons,
	titlesx,
	framesx,
	activeSpot,
	onSpotSelected,
}) => {
	const buttonRefs = useRef<(HTMLDivElement | null)[]>([]);
	const [buttonWidths, setButtonWidths] = useState<number[]>([]);

	const calculateButtonWidths = () => {
		const widths = buttonRefs.current.map((ref) => {
			if (ref) {
				return ref.offsetWidth + 2;
			}
			return 0;
		});

		setButtonWidths(widths);
	};

	useEffect(() => {
		if (buttons && buttons.length > 0) {
			calculateButtonWidths();
		}
	}, [buttons]);

	return (
		<DpContainer withoutmargin sx={combineSX([...(Array.isArray(framesx) ? framesx : [framesx])])}>
			<Grid
				sx={{
					display: 'flex',
					flexDirection: {
						xs: 'column',
						sm: 'row',
					},
					gap: '10px',
					alignItems: {
						sm: 'center',
					},
					mb: { xs: buttons && buttons?.length > 0 ? '10px' : '20px', sm: '20px' },
				}}
			>
				<DpH2
					sx={combineSX([
						newMostTitleSX(!!href),
						...(Array.isArray(titlesx) ? titlesx : [titlesx]),
					])}
				>
					<Linkable href={href}>{title}</Linkable>
				</DpH2>
				{buttons && buttons?.length > 0 ? (
					<Grid sx={DpCatalogEntryCarouselHeaderButtonsFrameSX}>
						{buttons.map((button, index: number) => {
							const active = activeSpot === button.spot;
							return (
								<Grid
									key={`id_top_button_${index}`}
									ref={(el: HTMLDivElement | null) => {
										buttonRefs.current[index] = el;
									}}
									sx={combineSX([
										DpCatalogEntryCarouselHeaderButtonSX(active),
										{ width: buttonWidths[index] || 'auto' },
									])}
									onClick={() => onSpotSelected(button.spot)}
								>
									{button.name}
								</Grid>
							);
						})}
					</Grid>
				) : null}
			</Grid>
		</DpContainer>
	);
};
